import { Pipe, PipeTransform } from '@angular/core';
import { isArray } from 'lodash';
import { ISupplierSummary } from '../../app/interfaces';

@Pipe({
  name: 'orderByReportIds'
})
export class OrderBy implements PipeTransform {

  transform(input: ISupplierSummary[] ): any {

    if ( !isArray(input) ) {
      return input;
    }

    const sortedArray = input.sort( (a, b) => {
      return a.reportIds.length - b.reportIds.length;
    }).reverse();

    //transform input somehow
    return sortedArray;
  }
}



// WEBPACK FOOTER //
// ./src/modules/supplier-selector/order-by.pipe.ts